// extracted by mini-css-extract-plugin
export default {"Page":"Order_Page__oM32n","Filters":"Order_Filters__EnIR3","List":"Order_List__yDy4W","Loader":"Order_Loader__lCtvP"};